import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Snackbar } from 'material-ui';

class ErrorSnackBar extends Component {

    constructor(props, context) {
        super(props, context);

        this.handleRequestClose = this.handleRequestClose.bind(this);
    }

    handleRequestClose() {
        this.props.onCloseError();
    }

    render() {

        const { hasError, errorObj } = this.props;

        let errorMessage = "";
        if(errorObj && errorObj.ExceptionMessage) {
            errorMessage = errorObj.ExceptionMessage
        }
        else if(errorObj && errorObj.message) {
            errorMessage = errorObj.message
        }

        return (
            <div>
                <Snackbar
                    open={hasError}
                    message={errorMessage}
                    autoHideDuration={10000}
                    onRequestClose={this.handleRequestClose}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({...state.common});
const mapDispatchToProps = dispatch => ({
    onCloseError: () =>
        dispatch({type: 'CLOSE_ERROR', payload: false})
})

ErrorSnackBar = connect(mapStateToProps, mapDispatchToProps)(ErrorSnackBar);

export default ErrorSnackBar;
